import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Calendar, Button, SMPopover, DataTable, DialogCampusGroupSingleActivity, Dialog } from "../../../../../";
import { Grid } from "@material-ui/core";
import { Views } from "react-big-calendar";
import moment from "moment";
import EventIcon from "@material-ui/icons/Event";
import ListIcon from "@material-ui/icons/List";
import { makeStyles } from "@material-ui/styles";
var useStyles = makeStyles(function (theme) {
  return {
    actionsOption: {
      display: "flex",
      justifyContent: "flex-end",
      margin: "16px 0"
    }
  };
});

var CampusGroupSingleTabActivities = function CampusGroupSingleTabActivities(props) {
  var _useState = useState("calendar"),
      _useState2 = _slicedToArray(_useState, 2),
      option = _useState2[0],
      setOption = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDialogActivity = _useState4[0],
      setOpenDialogActivity = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openDialogDeleteActivity = _useState6[0],
      setOpenDialogDeleteActivity = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      activitySelected = _useState8[0],
      setActivitySelected = _useState8[1];

  var _useState9 = useState("view"),
      _useState10 = _slicedToArray(_useState9, 2),
      variantDialogActivity = _useState10[0],
      setVariantDialogActivity = _useState10[1];

  var classes = useStyles(); // FUNCTIONS DIALOG

  var handleModalDialogActivity = function handleModalDialogActivity() {
    if (openDialogActivity) {
      setVariantDialogActivity("");
    }

    setOpenDialogActivity(!openDialogActivity);
  };

  var handleModalDialogDeleteActivity = function handleModalDialogDeleteActivity() {
    setOpenDialogDeleteActivity(!openDialogDeleteActivity);
  }; // FUNCTIONS POPOVER


  var handleItemPopover = function handleItemPopover(item, id) {
    switch (item) {
      case "view":
        setVariantDialogActivity("view");
        setActivitySelected(props.activities.find(function (activity) {
          return activity._id === id;
        }));
        handleModalDialogActivity();
        break;

      case "edit":
        setVariantDialogActivity("edit");
        setActivitySelected(props.activities.find(function (activity) {
          return activity._id === id;
        }));
        handleModalDialogActivity();
        break;

      case "delete":
        setActivitySelected(id);
        handleModalDialogDeleteActivity();
        break;

      default:
        break;
    }
  }; // eslint-disable-next-line no-unused-expressions


  props.translation ? props.translation.datatables ? props.translation.datatables.activities ? props.translation.datatables.activities.columns.find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(SMPopover, {
        data: tableMeta.rowData,
        type: "template",
        labels: [{
          label: props.translation ? props.translation.popovers ? props.translation.popovers.view || "View" : "View" : "View",
          name: "view",
          variant: "button",
          onItemClick: handleItemPopover
        }, {
          label: props.translation ? props.translation.popovers ? props.translation.popovers.edit || "Edit" : "Edit" : "Edit",
          name: "edit",
          variant: "button",
          onItemClick: handleItemPopover
        }, {
          label: props.translation ? props.translation.popovers ? props.translation.popovers["delete"] || "Delete" : "Delete" : "Delete",
          name: "delete",
          variant: "button",
          onItemClick: handleItemPopover
        }]
      });
    }
  } : null : null : null;

  var setContent = function setContent() {
    var content;

    switch (option) {
      case "calendar":
        content = /*#__PURE__*/React.createElement(Calendar, {
          events: props.events,
          onSelectEvent: function onSelectEvent(item) {
            if (item.idActivity) {
              setVariantDialogActivity("view");
              setActivitySelected(props.activities.find(function (activity) {
                return activity._id === item.idActivity;
              }));
              handleModalDialogActivity();
            }
          },
          messages: props.translation ? props.translation.calendar ? props.translation.calendar.messages : null : null,
          date: props.campusGroupData ? moment() > props.campusGroupData.date.start ? moment() > props.campusGroupData.date.end ? props.campusGroupData.date.end.toDate() : moment().toDate() : props.campusGroupData.date.start.toDate() : moment().toDate(),
          defaultView: Views.WEEK,
          onClickEventAgenda: function onClickEventAgenda(item) {// console.log("item clicked", item);
          }
        });
        break;

      case "list":
        content = /*#__PURE__*/React.createElement(Grid, {
          container: true
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: false,
          md: 3
        }), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          md: 6
        }, /*#__PURE__*/React.createElement(DataTable, {
          data: props.activities,
          translation: props.translation ? props.translation.datatables ? props.translation.datatables.activities : null : null
        })));
        break;

      default:
        break;
    }

    return content;
  };

  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Dialog, {
    open: openDialogDeleteActivity,
    onClose: handleModalDialogDeleteActivity,
    title: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_activity ? props.translation.dialogs.delete_activity.title || "Do you want to remove this activity?" : "Do you want to remove this activity?" : "Do you want to remove this activity?" : "Do you want to remove this activity?",
    text: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_activity ? props.translation.dialogs.delete_activity.text || "You will lose all content from this activity" : "You will lose all content from this activity" : "You will lose all content from this activity" : "You will lose all content from this activity",
    submit: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_activity ? props.translation.dialogs.delete_activity.buttons ? props.translation.dialogs.delete_activity.buttons.submit || "Delete" : "Delete" : "Delete" : "Delete" : "Delete",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleModalDialogDeleteActivity,
    cancel: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_activity ? props.translation.dialogs.delete_activity.buttons ? props.translation.dialogs.delete_activity.buttons.cancel || "Cancel" : "Cancel" : "Cancel" : "Cancel" : "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      props.handleDeleteActivity(activitySelected);
      handleModalDialogDeleteActivity();
    }
  }), /*#__PURE__*/React.createElement(DialogCampusGroupSingleActivity, {
    open: openDialogActivity,
    onClose: handleModalDialogActivity,
    onSubmitEdit: props.handleEditActivity,
    variant: variantDialogActivity,
    data: activitySelected,
    venues: props.venues,
    translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.activity || null : null : null
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.actionsOption
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: function onClick() {
      setOption("calendar");
    }
  }, /*#__PURE__*/React.createElement(EventIcon, {
    color: option === "calendar" ? "primary" : "inherit"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: function onClick() {
      setOption("list");
    }
  }, /*#__PURE__*/React.createElement(ListIcon, {
    color: option === "list" ? "primary" : "inherit"
  })))), setContent());
};

export { CampusGroupSingleTabActivities };